<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Aktualisasi PO</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Start Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="startDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="start_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="start_date" @change="handelChangeStartDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">End Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="4">
                        <v-menu v-model="endDateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="end_date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="end_date" @change="handelChangeEndDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedSize" class="compact-form" @change="handleChangeVolume"></v-select>
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading" type="table-tbody" />
                            <v-simple-table v-else fixed-header height="400" ref="tabelExport">
                                <template v-slot:default class="">
                                    <thead>
                                        <tr>
                                            <th>Outlet</th>
                                            <th>Target Sales</th>
                                            <th>Total PO</th>
                                            <th>Selisih</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(item, idx) in items" :key="idx">
                                            <td>{{ item.outlet_name }}</td>
                                            <td>{{ item.sales_target }}</td>
                                            <td>{{ item.total_po }}</td>
                                            <td>{{ item.selisih }}</td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th>TOTAL</th>
                                            <th>{{ totalSalesTarget }}</th>
                                            <th>{{ totalPO }}</th>
                                            <th>{{ totalSelisih }}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            start_date: '',
            startDateMenu: false,
            end_date: '',
            endDateMenu: false,
            headers: [],
            items: [],
            bottles: [],
            selectedSize: '490',
            isLoading: false,
        }
    },

    async created() {
        this.getBottles();

        this.fetchData();
    },

    computed: {
        totalSalesTarget() {
            return this.items.reduce((total, item) => {
                return total + (parseInt(item.sales_target) || 0)
            }, 0);
        },
        totalPO() {
            return this.items.reduce((total, item) => {
                return total + (parseInt(item.total_po) || 0)
            }, 0);
        },
        totalSelisih() {
            return this.items.reduce((total, item) => {
                return total + (parseInt(item.selisih) || 0)
            }, 0);
        }
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        handelChangeStartDate() {
            this.fetchData();
        },
        handelChangeEndDate() {
            this.fetchData();
        },
        handleChangeVolume() {
            this.fetchData();
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('getObjs', {
                    apidomain: `report-actual-po`,
                    parameter: `?start_date=${this.start_date}&end_date=${this.end_date}&size=${this.selectedSize}`,
                }));

                const data = response.data.data;

                this.start_date = data.start_date;
                this.end_date = data.end_date;
                this.items = data.items;
            } catch (error) {
                console.log('Error fetching report po : ', error);
            } finally {
                this.isLoading = false;
            }
        },
        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = 'Aktualisasi-PO.xlsx';

            writeFileXLSX(wb, fileName);
        },
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>